module.exports = __webpack_public_path__ + "static/img/长图设计-插画长图.c25d9a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/长图设计-插画长图.png
// module id = id6j
// module chunks = 1